export default __webpack_public_path__ + "static/media/silent-bell-icon.f1d451f0.svg";